// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".result-url[data-v-56c8f2d7],\n.result-label[data-v-56c8f2d7] {\n  font-family: var(--textFontTypeface, inherit);\n}\n.result-url[data-v-56c8f2d7] {\n  color: var(--textFontColor, var(--text-gray-900, inherit));\n  font-weight: var(--textFontWeight, inherit);\n}\n.result-label[data-v-56c8f2d7] {\n  color: var(--textFontColor, var(--text-theme-500, inherit));\n  font-weight: var(--textFontWeight, 700);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
